import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Bulk header-only refresh from Famous.
 *
 * Designed for the page-open hot path: kick this off before opening a view
 * that displays a known set of invoices so the user sees fresh amounts,
 * balances, and statuses without waiting on the nightly ingest.
 *
 * Intentionally silent — no success toast, no automatic cache invalidation.
 * The caller is responsible for sequencing follow-up reads (e.g. waiting on
 * `isPending` before firing the next query that should reflect fresh data).
 */
export function useRefreshArInvoiceHeadersFromFamous() {
  return useMutation(
    orpc.accountsReceivable.arInvoices.refreshHeadersFromFamous.mutationOptions(),
  );
}
